#import "../fragments/personFragment.graphql"

mutation updatePersonAttributes(
  $entityId: ID!
  $attributes: [AttributesInput]
) {
  person: updatePersonAttributes(entityId: $entityId, attributes: $attributes) {
    ...PersonFragment
  }
}
